import * as React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Error404 from "./components/error/404";
import { DynamicRouteManager } from "./components/routes/DynamicRouteManager";
import { appConstants } from "./utils/constants";
import { TokenProvider } from "./context/provider/tokenProvider";
import { DashboardProvider } from "./context/provider/dashboardProvider";

export default function App() {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <div className="content-error-background">
            <Error404 />
          </div>
        }
      />
      <Route
        path="Store/:qrValue/*"
        element={
          <DynamicRouteManager surveyType={appConstants.store}>
            <TokenProvider>
              <DashboardProvider>
                <Dashboard />
              </DashboardProvider>
            </TokenProvider>
          </DynamicRouteManager>
        }
      />
      <Route
        path="Invoice/:qrValue"
        element={
          <DynamicRouteManager surveyType={appConstants.invoice}>
            <TokenProvider>
              <DashboardProvider>
                <Dashboard />
              </DashboardProvider>
            </TokenProvider>
          </DynamicRouteManager>
        }
      />
    </Routes>
  );
}
